import React from "react";
import { useSiteSettings } from "@/lib/settings";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton({ prefilledMessage }) {
  const settings = useSiteSettings();
  const number = settings?.whatsapp_number || "";

  if (!number) return null;

  const clean = number.replace(/[^\d]/g, "");
  const msg = prefilledMessage ? `?text=${encodeURIComponent(prefilledMessage)}` : "";
  const href = `https://wa.me/${clean}${msg}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-pulse fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg flex items-center justify-center hover:scale-105 transition-transform duration-200"
      aria-label="WhatsApp"
      data-testid="wa-floating-btn"
    >
      <MessageCircle size={26} />
    </a>
  );
}
